import { createFileRoute } from "@tanstack/react-router";
import { useGetDefaultsQuery } from "api/TenantSlug/Setting/hooks";
import { AuthLayout } from "components/Layouts/AuthLayout/AuthLayout.tsx";
import { NoTenantAccessPage } from "components/UI/NoTenantAccessPage/NoTenantAccessPage.tsx";

export const Route = createFileRoute("/$tenantSlug/no-access/")({
    component: TenantNoAccessPage,
});

function TenantNoAccessPage() {
    const { tenantSlug } = Route.useParams();
    const defaultsQuery = useGetDefaultsQuery(tenantSlug);

    return (
        <AuthLayout title={defaultsQuery.data?.tenant.title} logo={defaultsQuery.data?.tenant.logo ?? undefined}>
            <NoTenantAccessPage
                tenantSlug={tenantSlug}
                tenantId={defaultsQuery.data?.tenant.id}
                allowAccessRequests={defaultsQuery.data?.tenant.allow_access_requests}
            />
        </AuthLayout>
    );
}
